import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Euro as EuroIcon } from '@mui/icons-material';
import { Controller } from 'react-hook-form';

const EuroInput = ({ control, name, rules, label, ...props }) => {
  const formatEuroValue = (value) => {
    // Remove tudo que não é dígito
    let numericValue = value.replace(/\D/g, '');
    
    // Adiciona zeros à esquerda se necessário para centavos
    if (numericValue.length === 1) numericValue = `00${numericValue}`;
    if (numericValue.length === 2) numericValue = `0${numericValue}`;
    
    // Formata como € X.XXX,XX
    const euros = numericValue.slice(0, -2) || '0';
    const cents = numericValue.slice(-2);
    
    // Adiciona separadores de milhar
    const formattedEuros = euros
      .split('')
      .reverse()
      .join('')
      .replace(/(\d{3})(?=\d)/g, '$1.')
      .split('')
      .reverse()
      .join('')
      .replace(/^\./, '');

    return `€ ${formattedEuros},${cents}`;
  };

  const handleEuroChange = (e, onChange) => {
    const rawValue = e.target.value.replace(/\D/g, '');
    const formattedValue = formatEuroValue(rawValue);
    onChange(formattedValue);
  };

  const handleKeyDown = (e) => {
    // Permite apenas backspace, delete, tab, escape, enter, números e teclas de navegação
    if (
      [46, 8, 9, 27, 13].includes(e.keyCode) ||
      (e.keyCode === 65 && e.ctrlKey === true) || // Ctrl+A
      (e.keyCode === 67 && e.ctrlKey === true) || // Ctrl+C
      (e.keyCode === 86 && e.ctrlKey === true) || // Ctrl+V
      (e.keyCode === 88 && e.ctrlKey === true) || // Ctrl+X
      (e.keyCode >= 35 && e.keyCode <= 39) // Home, End, setas
    ) {
      return;
    }
    
    // Bloqueia se não for número
    if ((e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{ 
        required: rules?.required || 'Custo é obrigatório',
        validate: {
          validFormat: (value) => 
            /^€ [0-9]{1,3}(\.?[0-9]{3})*(,[0-9]{2})?$/.test(value) || 
            'Formato inválido (ex: € 1.000,00)'
        },
        ...rules
      }}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label || "Custo Estimado *"}
          fullWidth
          error={!!fieldState.error}
          helperText={fieldState.error?.message || 'Ex: € 1.000,00'}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => handleEuroChange(e, field.onChange)}
          onKeyDown={handleKeyDown}
          placeholder="€ 0,00"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EuroIcon color={fieldState.error ? 'error' : 'action'} />
              </InputAdornment>
            ),
          }}
          {...props}
        />
      )}
    />
  );
};

export default EuroInput;